import React from 'react';

import { translate } from 'iss/strings';
import { PromptOnNavigation } from 'iss/widgets/PromptOnNavigation';
import Modal from 'iss/widgets/bootstrap/Modal';
import ProgressBar from 'iss/widgets/bootstrap/ProgressBar';

/** Props:
 * operationResults :: Result object
 * A result object like the ones emitted by runBatchOps  (utils/batchOps.jsx) Observables
 *
 * title :: Translation key
 * Dialog title
 *
 * inProgressMessage :: Translation key
 * Message to show while the operations are running
 *
 * success :: React dom
 * What to show when the operation succeeded
 *
 * failure :: React dom
 * What to show when the operation succeeded
 *
 **/
export function BatchOpResultsDialog({title, size, ...props}) {
  return <Modal title={translate(title)} visible={props.operationResults != null} size={size ? size : "large"}>
    <BatchOpResults {...props} />
  </Modal>;
}

function BatchOpResults({operationResults, inProgressMessage, renderSuccess, renderFailure}) {
  if (!operationResults) return null;

  if (!operationResults.complete) {
    return <OperationInProgress message={inProgressMessage} {...operationResults} />;
  }

  if (operationResults.success) {
    return renderSuccess;
  } else {
    return renderFailure;
  }
}

function OperationInProgress({message, progress, total = 0}) {
  return <Modal.Body>
    <PromptOnNavigation when={true} message={translate("common.batchOpInProgress")} />
    <p>{translate(message, {count: total})}</p>
    <ProgressBar progress={progress/total} text={progress + "/" + total} />
  </Modal.Body>;
}



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/batchOps/BatchOpResultsDialog.jsx